module.exports = __webpack_public_path__ + "static/media/14-min.jpg.af3361a2.webp";